<div #container class="position-relative">
  <div class="" *ngIf="student && settings" style="min-height: 700px" [ngClass]="{ 'small-layout': smallLayout, 'container-fluid container-fluid--tab': !smallLayout, xxs: componentWidth < 1100 && studentId > 0 }">
    <div class="rights mb-5" *ngIf="isHr || _studentId != currentEmployee.studentId">
      <!-- Main Content -->
      <label class="form-label fw-bold"> {{ 'development_rights' | label : 'goals' | async }} {{ student.firstName }} {{ student.lastName }} </label>
      <!-- Checkboxes of settings employee -->
      <div class="d-flex align-items-center">
        <div class="form-check form-switch d-flex custom-switch">
          <input class="form-check-input cursor-pointer" type="checkbox" [(ngModel)]="rights.canCreate" id="allowGoalsCreate" (change)="saveEmployeeRights($event)" />
          <label class="form-check-label me-2" for="allowGoalsCreate"></label>
          <span>{{ 'allow_development_goals_create' | label : 'goals' | async }}</span>
        </div>

        <div class="ms-5">
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer" type="checkbox" [(ngModel)]="rights.canEdit" id="allowGoalsCreate" (change)="saveEmployeeRights($event)" />
            <label class="form-check-label me-2" for="allowGoalsCreate"></label>
            <span>{{ 'allow_development_goals_edit' | label : 'goals' | async }}</span>
          </div>
        </div>

        <div class="ms-5">
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer" type="checkbox" [(ngModel)]="rights.canDelete" id="allowGoalsDelete" (change)="saveEmployeeRights($event)" />
            <label class="form-check-label me-2" for="allowGoalsDelete"></label>
            <span>{{ 'allow_development_goals_delete' | label : 'goals' | async }}</span>
          </div>
        </div>

        <div class="ms-5">
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer" type="checkbox" [(ngModel)]="rights.canConnect" id="allowGoalLinking" (change)="saveEmployeeRights($event)" />
            <label class="form-check-label me-2" for="allowGoalLinking"></label>
            <span>{{ 'is_allowed_to_link_goals' | label : 'goals' | async }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex position-relative">
      <div style="min-width: 0" class="flex-grow-1">
        <div class="">
          <!-- Scrollable container -->
          <div class="me-2">
            <div style="position: relative">
              <ng-container *ngIf="!conversationGoals || !conversationGoals.length">
                <h1 *ngIf="settings.allowCompanyGoals" class="ms-2">{{ 'company_objectives' | label : 'goals' | async }}</h1>
              </ng-container>

              <!-- company objectives -->
              <div class="row mb-4 ms-2 me-1">
                <ng-container *ngIf="!conversationGoals || !conversationGoals.length">
                  <ul class="list-group list-group-flush" *ngIf="settings.allowCompanyGoals">
                    <li class="list-group-item">
                      <div class="d-flex gap-2 align-items-center companyObjectives--table header">
                        <div class="w-100" (click)="changeSortCompanyObjectives(1)">
                          <span>
                            {{ 'name' | label : 'general' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 1 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 1 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 1
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-100" (click)="changeSortCompanyObjectives(2)">
                          <span>
                            {{ 'description' | label : 'goals' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 2 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 2 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 2
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-100" *ngIf="settings.companyObjectiveAllowCategories && categories && categories.length" (click)="changeSortCompanyObjectives(3)">
                          <span>
                            {{ 'category' | label : 'general' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 3 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 3 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 3
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-50" (click)="changeSortCompanyObjectives(4)">
                          <span>
                            {{ 'status' | label : 'general' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 4 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 4 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 4
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-100" (click)="changeSortCompanyObjectives(5)">
                          <span>
                            {{ 'due_date' | label : 'goals' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 5 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 5 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 5
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-100" (click)="changeSortCompanyObjectives(6)">
                          <span>
                            {{ 'create_by_on' | label : 'goals' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 6 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 6 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 6
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-50" *ngIf="settings.companyObjectiveWeightHr" (click)="changeSortCompanyObjectives(7)">
                          <span>
                            {{ 'weight' | label : 'goals' | async }}
                            <i
                              class="fas cursor-pointer"
                              [ngClass]="{
                                'fa-sort-up': sortCompanyObjectives.column == 7 && sortCompanyObjectives.dir,
                                'fa-sort-down': sortCompanyObjectives.column == 7 && !sortCompanyObjectives.dir,
                                'fa-sort': sortCompanyObjectives.column != 7
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="w-50" *ngIf="settings.scoreCompanyGoals && enableScoring">
                          <span>
                            {{ 'score' | label : 'general' | async }}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul class="list-group mb-5" *ngIf="settings.allowCompanyGoals">
                    <li class="list-group-item list-group-item-action" *ngFor="let companyObjective of companyObjectives" (click)="openCompanyObjectiveDetail(companyObjective)" [ngClass]="{ 'active-row': companyObjective.id == activeCompanyObjective?.id }">
                      <div class="d-flex gap-2 align-items-center companyObjectives--table">
                        <div class="w-100" [title]="companyObjective.name">{{ companyObjective.name }}</div>
                        <div class="w-100">
                          {{ companyObjective.description }}
                        </div>
                        <div class="w-100" *ngIf="settings.companyObjectiveAllowCategories && categories && categories.length">
                          {{ companyObjective.categoryName }}
                        </div>
                        <div class="w-50">
                          <span class="badge" [style.backgroundColor]="companyObjective.statusColor">
                            {{ companyObjective.statusName }}
                          </span>
                        </div>
                        <div class="w-100">
                          <td>{{ companyObjective.dueDate | employeeDate | async }}</td>
                        </div>
                        <div class="w-100">
                          <div class="d-flex align-items-center">
                            <app-profile-picture class="mx-2" [title]="companyObjective?.creator" [text]="companyObjective?.creator" [whoId]="companyObjective.createdById" [whoKind]="companyObjective.createdByKindId == 4 ? 3 : companyObjective.createdByKindId" [width]="20"> </app-profile-picture>
                            <div class="ms-3">
                              {{ companyObjective.dateCreated | employeeDate | async }}
                            </div>
                          </div>
                        </div>
                        <div class="w-50" *ngIf="settings.companyObjectiveWeightHr">{{ companyObjective.weight }}%</div>
                        <div class="w-50" *ngIf="settings.scoreCompanyGoals && enableScoring">{{ companyObjective.score }}%</div>
                      </div>
                    </li>
                  </ul>
                </ng-container>

                <!-- Performance objectives  -->
                <h1 class="performance_objectives mt-4 pb-0 ps-0">
                  {{ 'individual_performance_objectives' | label : 'goals' | async }}<span *ngIf="settings.allowTeamGoals"> {{ 'team_performance_objectives' | label : 'goals' | async }}</span>
                </h1>
                <p *ngIf="settings.useReviewPeriod" class="ps-0">{{ 'review_year' | label : 'goals' | async }} {{ currentReviewPeriod.reviewYear }}</p>
                <div class="pt-4 pb-2 ps-0">
                  <div class="d-flex align-items-center">
                    <button class="btn mb-3" type="submit" (click)="openAddObjectiveModal(addObjectiveModal)" *ngIf="!(isEmployee && !rights.canCreate)">+ {{ 'add_goal' | label : 'managerdashboard' | async }}</button>
                  </div>
                  <!-- Performance objectives for alowcategories setttings -->
                  <ng-container *ngIf="settings.allowCategories; else noCategoriesSettings">
                    <ng-container *ngFor="let objectiveCategory of objectivesPerCategory">
                      <ng-container *ngIf="objectiveCategory?.objectives?.length > 0">
                        <h2>{{ objectiveCategory.category.name }}</h2>
                        <ng-template *ngTemplateOutlet="objectivesTable; context: { objectives: objectiveCategory.objectives, objectiveCategory: objectiveCategory }"></ng-template>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-container *ngIf="(!conversationGoals || conversationGoals.length == 0) && !enableScoring">
                  <!-- Previous objectives head -->
                  <ul class="list-group list-group-flush mt-4">
                    <li class="list-group-item">
                      <div class="d-flex justify-content-end align-items-end objectives--table">
                        <button class="btn btn-sm" *ngIf="allCollapsed" (click)="collapseAll()">
                          {{ 'collapse_all_sections' | label : 'conversations' | async }}
                          <i class="i-link fas fa-chevron-down ms-2"></i>
                        </button>
                        <button class="btn btn-sm" *ngIf="!allCollapsed" (click)="collapseAll()">
                          {{ 'fold_out_all_sections' | label : 'conversations' | async }}
                          <i class="i-link fas fa-chevron-up ms-2"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                  <ul class="list-group">
                    <!-- Previous objectives -->
                    <li class="list-group-item list-group-item-action" [ngClass]="{ selected: activeListItemIndex === 2 }">
                      <div class="d-flex align-items-center objectives--table" (click)="toggleCollapse(2, 'previous_goals')">
                        <div class="collapse-name">
                          <i class="me-4 far fa-fw cursor-pointer" (click)="toggleCollapse(2, 'previous_goals'); $event.stopPropagation()" [ngClass]="collapseGoals ? 'fa-minus-square' : 'fa-plus-square'"></i>
                        </div>
                        <div class="previous_goals">{{ 'previous_goals' | label : 'goals' | async }}</div>
                      </div>
                      <!-- Parent collapse -->
                      <div [ngbCollapse]="!collapseGoals">
                        <ng-container *ngIf="settings.useReviewPeriod; else statusPreviousObjectivesCollapse">
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item mt-4" style="background-color: transparent">
                              <div class="d-flex align-items-center previousobjectives--table header">
                                <div class="collapse-year">
                                  <i class="me-4 far fa-fw cursor-pointer" (click)="collapseAllPreviousObjectives()" [ngClass]="allPreviousObjectivesCollapsed ? 'fa-minus-square' : 'fa-plus-square'"></i>
                                </div>
                                <div class="previous_objective_year">
                                  {{ 'review_year' | label : 'goals' | async }}
                                </div>
                              </div>
                            </li>
                          </ul>
                          <ul class="list-group">
                            <ng-container *ngFor="let previousObjectiveGroup of previousObjectivesGrouped; let i = index">
                              <li class="list-group-item list-group-item-action">
                                <div class="d-flex align-items-center objectives--table" (click)="togglePreviousObjectiveCollapse(previousObjectiveGroup.previousObjectivesList)">
                                  <div class="collapse-year">
                                    <i class="me-4 far fa-fw cursor-pointer" (click)="togglePreviousObjectiveCollapse(previousObjectiveGroup.previousObjectivesList); $event.stopPropagation()" [ngClass]="previousObjectiveGroup.previousObjectivesList.previousObjectivesCollapse ? 'fa-minus-square' : 'fa-plus-square'"></i>
                                  </div>
                                  <div class="company-year">{{ previousObjectiveGroup.year }}</div>
                                </div>
                                <!-- child collapse -->
                                <div [ngbCollapse]="!previousObjectiveGroup.previousObjectivesList.previousObjectivesCollapse">
                                  <ng-container *ngIf="previousObjectivesGrouped.length > 0; else noPreviousObjectives">
                                    <ng-container *ngTemplateOutlet="deletedObjectivesTable; context: { previousObjectives: previousObjectiveGroup.previousObjectives }"></ng-container>
                                  </ng-container>
                                  <ng-template #noPreviousObjectives>
                                    <p class="text-muted mt-4">{{ 'no_results' | label : 'goals' | async }}</p>
                                  </ng-template>
                                </div>
                              </li>
                            </ng-container>
                          </ul>
                        </ng-container>
                      </div>

                      <ng-template #statusPreviousObjectivesCollapse>
                        <ng-container *ngIf="previousObjectivesGrouped.length > 0; else noPreviousObjectives">
                          <ng-container *ngTemplateOutlet="deletedObjectivesTable; context: { previousObjectives: previousObjectives }"></ng-container>
                        </ng-container>
                        <ng-template #noPreviousObjectives>
                          <p class="text-muted mt-4">{{ 'no_results' | label : 'goals' | async }}</p>
                        </ng-template>
                      </ng-template>
                    </li>
                    <!-- Deleted objectives -->
                    <li *ngIf="!settings.hideDeletedPerformanceGoals" class="list-group-item list-group-item-action" [ngClass]="{ selected: activeListItemIndex === 3 }">
                      <div class="d-flex align-items-center objectives--table" (click)="toggleCollapse(3, 'deletedGoals')">
                        <div class="collapse-name">
                          <i class="me-4 far fa-fw cursor-pointer" (click)="toggleCollapse(3, 'deletedGoals'); $event.stopPropagation()" [ngClass]="collapseDeletedGoals ? 'fa-minus-square' : 'fa-plus-square'"></i>
                        </div>
                        <div class="previous_goals">{{ 'deleted_goals' | label : 'goals' | async }}</div>
                      </div>
                      <div [ngbCollapse]="!collapseDeletedGoals">
                        <ng-container *ngIf="deletedObjectivesGrouped.length > 0; else noDeletedObjectives">
                          <!--Setting value is incorrect, useReviewPeriod should be false when using status, but yet it is not!-->
                          <ng-container *ngIf="settings.useReviewPeriod; else statusDeletedObjectivesCollapse">
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item mt-4" style="background-color: transparent">
                                <div class="d-flex align-items-center previousobjectives--table header">
                                  <div class="collapse-year">
                                    <i class="me-4 far fa-fw cursor-pointer" (click)="collapseAllDeletedObjectives()" [ngClass]="allDeletedObjectivesCollapsed ? 'fa-minus-square' : 'fa-plus-square'"></i>
                                  </div>
                                  <div class="previous_objective_year">
                                    {{ 'review_year' | label : 'goals' | async }}
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <ul class="list-group">
                              <ng-container *ngFor="let deletedObjectiveGroup of deletedObjectivesGrouped; let i = index">
                                <li class="list-group-item list-group-item-action">
                                  <div class="d-flex align-items-center objectives--table" (click)="toggleDeletedObjectiveCollapse(deletedObjectiveGroup.deletedObjectivesList)">
                                    <div class="collapse-year">
                                      <i class="me-4 far fa-fw cursor-pointer" (click)="toggleDeletedObjectiveCollapse(deletedObjectiveGroup.deletedObjectivesList); $event.stopPropagation()" [ngClass]="deletedObjectiveGroup.deletedObjectivesList.deletedObjectivesCollapse ? 'fa-minus-square' : 'fa-plus-square'"></i>
                                    </div>
                                    <div class="company-year">{{ deletedObjectiveGroup.year }}</div>
                                  </div>
                                  <div [ngbCollapse]="!deletedObjectiveGroup.deletedObjectivesList.deletedObjectivesCollapse">
                                    <ng-container *ngTemplateOutlet="deletedObjectivesTable; context: { previousObjectives: deletedObjectiveGroup.deletedObjectives }"></ng-container>
                                  </div>
                                </li>
                              </ng-container>
                            </ul>
                          </ng-container>

                          <!--When we filter by STATUS instead show only ONE table instead of groups per year.-->
                          <ng-template #statusDeletedObjectivesCollapse>
                            <ng-container *ngTemplateOutlet="deletedObjectivesTable; context: { previousObjectives: deletedObjectives }"></ng-container>
                          </ng-template>
                        </ng-container>
                      </div>
                      <ng-template #noDeletedObjectives>
                        <p class="text-muted mt-4">{{ 'no_results' | label : 'goals' | async }}</p>
                      </ng-template>
                    </li>
                  </ul>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- right side -->
      <div class="" *ngIf="!showCompanyObjectiveDetail && activeObjective; else companyDetails" [ngClass]="{ smaller: _studentId != currentEmployee.studentId || whoisKind != 3 }">
        <div class="spacing"></div>
        <div *ngIf="activeObjective" class="active-objective">
          <div class="row g-3">
            <div class="col-md-12">
              <h2 class="text-break">{{ activeObjective?.name }}</h2>
            </div>

            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <app-profile-picture [title]="activeObjective?.creator" [text]="activeObjective?.creator" [whoId]="activeObjective?.createdById" [whoKind]="activeObjective?.createdByType == 4 ? 3 : activeObjective?.createdByType" [width]="40"> </app-profile-picture>
                <div class="ms-3">
                  {{ activeObjective?.creator }} {{ 'on' | label : 'learnpathEssDetail' | async }}
                  {{ activeObjective?.createdDate | employeeDate | async }}
                </div>
              </div>
            </div>
            <div class="col-md-12" *ngIf="activeObjective?.description">
              <label class="form-label">{{ 'description' | label : 'goals' | async }}</label>
              <div class="form-control pre-line">{{ activeObjective.description }}</div>
            </div>
            <!-- KPI -->
            <div class="col-md-12" *ngIf="activeObjective?.kpi && settings.hasKPI">
              <label class="form-label">{{ 'kpi' | label : 'goals' | async }}</label>
              <div class="form-control pre-line">
                {{ activeObjective.kpi }}
              </div>
            </div>
            <!-- attachment-->
            <div class="col-md-12" *ngIf="settings.allowAttachment && activeObjective.attachments && activeObjective.attachments.length">
              <label for="attachment" class="form-label" style="margin-right: 15px"> {{ 'message_attachments' | label : 'homepage' | async }}</label>
            </div>
            <div *ngIf="settings.allowAttachment">
              <div *ngIf="activeObjective.attachments && activeObjective.attachments.length">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let attachment of activeObjective.attachments; index as attachmentIndex">
                    <span class="download-attachment">
                      {{ attachment.fileName }}
                      <i class="fa fa-fw fa-paperclip fs-6 primary-icon"></i>
                    </span>

                    <div class="d-flex align-items-center">
                      <a class="cursor-pointer me-2" (click)="downloadAttachment(attachment)">
                        <i class="fa fa-fw fa-download fs-5"></i>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <hr class="mt-4 mb-4" *ngIf="linkableObjectives.length" />
            <!-- linked goals -->
            <div class="col-md-12 mt-4" *ngIf="activeObjective?.linkedObjectiveId != 0 && linkableObjectives.length">
              <div class="row">
                <div class="col-md-11">
                  <!--<label *ngIf="activeObjective.attachments.length > 0" for="linkedObjectiveId" class="form-label" style="margin-right: 15px">
                  {{ 'message_attachments' | label : 'homepage' | async }} <span>{{ activeObjective.linkedObjectiveName }}</span>
                </label>-->
                </div>
                <div class="col-md-1">
                  <a class="cursor-pointer table-icon-link" (click)="showCascade(activeObjective.linkedObjectiveId)" [ngbTooltip]="'show_cascade' | label : 'goals' | async" placement="left" container="body">
                    <i class="fas fa-sitemap fs-5 primary-icon"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- linkable goals -->
            <div class="col-md-12 mt-4" *ngIf="linkableObjectives.length">
              <label for="linkToManagerGoal" class="form-label">
                {{ 'link_to_manager_goal_1' | label : 'goals' | async }}
                <span class="fw-bold">{{ activeObjective.name }}</span>
                {{ 'link_to_manager_goal_2' | label : 'goals' | async }}
              </label>
              <div>
                <div class="linkable" *ngIf="linkableObjectives && linkableObjectives.length">
                  <ng-container *ngFor="let linkable of linkableObjectives; let i = index">
                    <div *ngIf="linkable.objectiveId != activeObjective.objectiveId">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="linkable" [id]="'linkable' + i" (click)="linkObjective(linkable, $event)" [checked]="linkable.objectiveId == activeObjective.linkedObjectiveId" [disabled]="!detailEditable || (!isHr && ((isEmployee && !rights.canConnect) || activeObjective.createdById != currentEmployee.studentId))" />
                        <label class="form-check-label" for="{{ 'linkable' + i }}">
                          <span class="fw-bold">{{ linkable.name }}</span>
                          <div class="description">{{ linkable.description }}</div>
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <p *ngIf="!linkableObjectives || linkableObjectives.length <= 0">
                  {{ 'no-results' | label : 'finalyse-competences' | async }}
                </p>
              </div>
            </div>
            <hr class="mt-4 mb-4" />
            <!-- comments -->
            <div class="comments">
              <!-- Add Comment Section (Hidden when Deleted Objective is Active) -->
              <div class="row g-2 mb-5" *ngIf="objectiveCommentAdding && detailEditable">
                <div class="col-12">
                  <textarea name="description" id="description" class="form-control" [(ngModel)]="objectiveCommentAdding.description" rows="4" [style.resize]="'none'" placeholder="{{ 'add_comment' | label : 'goals' | async }}..."> </textarea>
                </div>
                <div class="col-md-12">
                  <div class="d-flex">
                    <div class="flex-grow-1 d-flex">
                      <!-- <div class="form-check mb-0">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="objectiveCommentAdding.visible" id="visible" [disabled]="objectiveCommentAdding && ((objectiveCommentAdding.description && objectiveCommentAdding.description.length == 0) || !objectiveCommentAdding.description)" />
                        <label class="form-check-label" for="visible">
                          {{ 'visible_comment' | label : 'goals' | async }}
                        </label>
                      </div> -->
                      <label for="commentVisibility" class="col-form-label me-4">{{ 'comment_visibility' | label : 'goals' | async }}</label>
                      <select id="commentVisibility" class="form-select form-select-sm" [(ngModel)]="objectiveCommentAdding.commentKind">
                        <option *ngIf="settings.performanceObjectivesAllowPrivateComments" [ngValue]="CommentKind.PrivateComment">
                          {{ 'comment_setting_1' | label : 'goals' | async }}
                        </option>
                        <ng-container *ngIf="!isEmployee">
                          <ng-container *ngIf="settings.performanceObjectivesAllowPrivateCommentsSharedWithinOwnRole">
                            <option *ngIf="isCHR" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_hr_1' | label : 'goals' | async }}
                            </option>
                            <option *ngIf="isLHR" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_hr_2' | label : 'goals' | async }}
                            </option>
                            <option *ngIf="isSupervisor" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_1' | label : 'goals' | async }}
                            </option>
                            <option *ngIf="isDelegate" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_2' | label : 'goals' | async }}
                            </option>
                            <option *ngIf="isMatrixManager" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_3' | label : 'goals' | async }}
                            </option>
                            <option *ngIf="isN2" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                              {{ 'private_comment_shared_with_others_4' | label : 'goals' | async }}
                            </option>
                          </ng-container>
                          <ng-container *ngIf="settings.performanceObjectivesAllowPrivateCommentsSharedBetweenManagersOrHr">
                            <!-- CHR -->
                            <option *ngIf="isCHR" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_HR_1' | label : 'goals' | async }}
                            </option>

                            <!-- LHR -->
                            <option *ngIf="isLHR" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_HR_2' | label : 'goals' | async }}
                            </option>

                            <!-- Manager -->
                            <option *ngIf="isSupervisor" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_manager_1' | label : 'goals' | async }}
                            </option>

                            <!-- Delegate manager -->
                            <option *ngIf="isDelegate" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_manager_2' | label : 'goals' | async }}
                            </option>

                            <!-- Matrix manager -->
                            <option *ngIf="isMatrixManager" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_manager_3' | label : 'goals' | async }}
                            </option>

                            <!-- N+2 manager -->
                            <option *ngIf="isN2" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                              {{ 'comment_setting_shared_with_manager_4' | label : 'goals' | async }}
                            </option>
                          </ng-container>
                        </ng-container>
                        <option *ngIf="settings.performanceObjectivesAllowSharedComments" [ngValue]="CommentKind.SharedComment">
                          {{ 'comment_setting_4' | label : 'goals' | async }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-end mt-3">
                  <button class="btn btn-sm ms-3" (click)="addComment(activeObjective)" [disabled]="objectiveCommentAdding && ((objectiveCommentAdding.description && objectiveCommentAdding.description.length == 0) || !objectiveCommentAdding.description)">
                    {{ 'save' | label : 'general' | async }}
                  </button>
                </div>
              </div>
              <!-- Log -->
              <div class="row g-3">
                <ng-container *ngFor="let comment of objectiveComments">
                  <!-- <div class="col-12" *ngIf="(isHr && comment.viewableByAdmin) || (isManager && comment.viewableByMgr) || (!isManager && comment.viewableByStudent) || currentEmployee.studentId == comment.createdById"> -->
                  <div class="col-12" *ngIf="checkWhoCanSeeComment(comment)">
                    <div class="card comment position-relative">
                      <div class="card-body">
                        <div class="d-flex align-items-start">
                          <div class="profile-picture me-3">
                            <app-profile-picture class="mx-2" [text]="comment.creatorName" [whoId]="comment.createdById" [whoKind]="comment.createdByKind == 4 ? 3 : comment.createdByKind" [width]="20"> </app-profile-picture>
                          </div>
                          <div class="flex-grow-1 min-w-0">
                            <h5 class="mb-1 fw-bold">
                              {{ comment.creatorName }}
                            </h5>
                            <ng-container *ngIf="comment.commentName == null">
                              <div class="comment-meta-row">
                                <i
                                  class="fas text-muted"
                                  [ngClass]="{
                                    'fa-lock': comment.commentKind === CommentKind.PrivateComment,
                                    'fa-lock-open': comment.commentKind != CommentKind.PrivateComment
                                  }"
                                  [ngbTooltip]="getCommentKindLabel(comment) | label : 'goals' | async"
                                  placement="top"
                                  container="body"
                                >
                                </i>

                                <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.PrivateComment">
                                  {{ 'comment_setting_1' | label : 'goals' | async }}
                                </small>

                                <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.PrivateCommentSharedWithinOwnRole">
                                  <!-- CHR -->
                                  <ng-container *ngIf="isCHR">
                                    {{ 'private_comment_shared_with_others_hr_1' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- LHR -->
                                  <ng-container *ngIf="isLHR">
                                    {{ 'private_comment_shared_with_others_hr_2' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Manager -->
                                  <ng-container *ngIf="isSupervisor && !isDelegate && !isMatrixManager && !isN2">
                                    {{ 'private_comment_shared_with_others_1' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Delegate manager -->
                                  <ng-container *ngIf="isDelegate">
                                    {{ 'private_comment_shared_with_others_2' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Matrix manager -->
                                  <ng-container *ngIf="isMatrixManager">
                                    {{ 'private_comment_shared_with_others_3' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- N+2 manager -->
                                  <ng-container *ngIf="isN2">
                                    {{ 'private_comment_shared_with_others_4' | label : 'goals' | async }}
                                  </ng-container>
                                </small>
                                <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                                  <!-- CHR -->
                                  <ng-container *ngIf="isCHR">
                                    {{ 'comment_setting_shared_with_HR_1' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- LHR -->
                                  <ng-container *ngIf="isLHR">
                                    {{ 'comment_setting_shared_with_HR_2' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Manager -->
                                  <ng-container *ngIf="isSupervisor && !isDelegate && !isMatrixManager && !isN2">
                                    {{ 'comment_setting_shared_with_manager_1' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Delegate manager -->
                                  <ng-container *ngIf="isDelegate">
                                    {{ 'comment_setting_shared_with_manager_2' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- Matrix manager -->
                                  <ng-container *ngIf="isMatrixManager">
                                    {{ 'comment_setting_shared_with_manager_3' | label : 'goals' | async }}
                                  </ng-container>

                                  <!-- N+2 manager -->
                                  <ng-container *ngIf="isN2">
                                    {{ 'comment_setting_shared_with_manager_4' | label : 'goals' | async }}
                                  </ng-container>
                                </small>

                                <small class="text-muted" *ngIf="comment.commentKind == CommentKind.SharedComment">
                                  {{ 'comment_setting_4' | label : 'goals' | async }}
                                </small>
                              </div>
                            </ng-container>
                            <small class="text-secondary d-block mt-2 mb-2">{{ comment.dateCreated | employeeDate | async }}</small>
                            <div *ngIf="comment.commentName" class="fw-bold mb-1">{{ comment.commentName }}</div>
                            <div class="comment-description" [innerHTML]="comment.description"></div>
                          </div>
                        </div>
                      </div>
                      <button class="btn btn-sm delete position-absolute comment-delete" style="top: 10px; right: 10px" (click)="deleteLogItem(comment)" *ngIf="comment.createdByKind == whoisKind && comment.createdById == currentEmployee.studentId && comment.commentType != 9 && settings.deletableChangeLog && detailEditable">
                        <i class="fas fa-trash red-icon"></i>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noresults>
        <p>{{ 'no_results' | label : 'goals' | async }}</p>
      </ng-template>

      <!-- Performance objectives when "working with categories" is turned off -->
      <ng-template #noCategoriesSettings>
        <ng-container *ngIf="!settings.allowCategories">
          <ng-template *ngTemplateOutlet="objectivesTable; context: { objectives: performanceObjectives }"></ng-template>
        </ng-container>
      </ng-template>
      <ng-template #companyDetails>
        <div class="company_spacing"></div>
        <div *ngIf="activeCompanyObjective" class="active-objective" style="margin-top: 66px">
          <div class="row g-3">
            <div class="col-md-12">
              <h2 class="text-break">{{ activeCompanyObjective?.name }}</h2>
            </div>

            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <app-profile-picture class="mx-2" [title]="activeCompanyObjective?.creator" [text]="activeCompanyObjective?.creator" [whoId]="activeCompanyObjective?.createdById" [whoKind]="activeCompanyObjective?.createdByKindId == 4 ? 3 : activeCompanyObjective?.createdById" [width]="20"> </app-profile-picture>
                <div class="ms-3">
                  {{ activeCompanyObjective?.creator }} {{ 'on' | label : 'learnpathEssDetail' | async }}
                  {{ activeCompanyObjective?.dateCreated | employeeDate | async }}
                </div>
              </div>
            </div>

            <div class="col-md-12 mt-3" *ngIf="activeCompanyObjective.description">
              <label class="form-label">{{ 'description' | label : 'goals' | async }}</label>
              <div class="d-flex">
                <span>
                  {{ activeCompanyObjective.description }}
                </span>
              </div>
            </div>

            <!-- KPI -->
            <div class="col-md-12 mt-3" *ngIf="activeCompanyObjective?.kpi">
              <label class="form-label">{{ 'kpi' | label : 'goals' | async }}</label>
              <div class="d-flex">
                <span>
                  {{ activeCompanyObjective.kpi }}
                </span>
              </div>
            </div>

            <!-- attachment-->
            <div class="col-md-12 mt-3" *ngIf="settings.allowAttachment && activeCompanyObjective.attachments && activeCompanyObjective.attachments.length">
              <label for="attachment" class="form-label fw-bold" style="margin-right: 15px">
                {{ 'message_attachments' | label : 'homepage' | async }}
              </label>
            </div>
            <div *ngIf="settings.allowAttachment">
              <div *ngIf="activeCompanyObjective.attachments && activeCompanyObjective.attachments.length">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let attachment of activeCompanyObjective.attachments; index as attachmentIndex">
                    <span class="download-attachment cursor-pointer"> {{ attachment.fileName }}<i class="fa fa-fw fa-paperclip fs-6 primary-icon"></i> </span>
                    <div class="d-flex align-items-center">
                      <a class="cursor-pointer me-2" (click)="downloadAttachment(attachment)">
                        <i class="fa fa-fw fa-download fs-5"></i>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- Modal edit performance objective -->
<ng-template #EditPerformanceModal let-modal>
  <div class="modal-header">
    <h2 class="modal-title">{{ 'edit_objective' | label : 'goals' | async }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <app-employee-performance-objective-edit #objectiveEdit [objective]="activeObjective" [isExisting]="true" [showWeight]="showWeight" [requiredWeight]="requiredWeight"></app-employee-performance-objective-edit>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="closeModal()">
      {{ 'cancel' | label : 'general' | async }}
    </button>
    <button type="button" class="btn" [disabled]="objectiveEdit?.form?.invalid" (click)="savePerformanceObjective(activeObjective, objectiveEdit.mutableObjective); modal.dismiss()">
      {{ 'save' | label : 'general' | async }}
    </button>
  </div>
</ng-template>

<!-- Add new objective -->
<ng-template #addObjectiveModal let-modal>
  <div class="modal-header">
    <h2 class="modal-title">
      {{ 'add_goal' | label : 'managerdashboard' | async }}
    </h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <app-employee-performance-objective-edit #objectiveEdit [objective]="objectiveEditing" [showWeight]="showWeight" [requiredWeight]="requiredWeight" [completedConversation]="completedConversation"></app-employee-performance-objective-edit>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="closeModal()">
      {{ 'cancel' | label : 'general' | async }}
    </button>
    <button type="button" class="btn" (click)="addObjective(objectiveEdit.mutableObjective); modal.dismiss()" [disabled]="objectiveEdit?.form?.invalid">
      {{ 'save' | label : 'general' | async }}
    </button>
  </div>
</ng-template>

<ng-template #deletedObjectivesTable let-previousObjectives="previousObjectives">
  <div class="pt-4 pb-2">
    <ul class="list-group">
      <li class="list-group-item">
        <div class="d-flex align-items-center objectives--table header">
          <div class="w-100">
            <span>
              {{ 'name' | label : 'general' | async }}
            </span>
          </div>
          <div class="w-100" *ngIf="settings.allowTeamGoals && types && types.length">
            <span>
              {{ 'type' | label : 'goals' | async }}
            </span>
          </div>
          <div class="w-100" *ngIf="settings.allowCategories && categories && categories.length">
            <span>
              {{ 'category' | label : 'general' | async }}
            </span>
          </div>
          <div class="w-50">
            <span>
              {{ 'status' | label : 'general' | async }}
            </span>
          </div>
          <div class="w-100">
            <span>
              {{ 'due_date' | label : 'goals' | async }}
            </span>
          </div>
          <div class="w-100">
            <span>
              {{ 'create_by_on' | label : 'goals' | async }}
            </span>
          </div>
          <div class="w-50" *ngIf="showWeight">
            <span>
              {{ 'weight' | label : 'goals' | async }}
            </span>
          </div>
        </div>
      </li>
      <ng-container *ngFor="let objective of previousObjectives">
        <li class="list-group-item list-group-item-action" (click)="openDeletedObjectiveDetail(objective)" [ngClass]="{ 'active-row': objective.objectiveId == activeObjective?.objectiveId }">
          <div class="d-flex align-items-center objectives--table">
            <div class="w-100 text-break" [title]="objective.name">{{ objective.name }}</div>
            <div class="w-100 text-break" [title]="objective.typeName" *ngIf="settings.allowTeamGoals && types && types.length">{{ objective.typeName }}</div>
            <div class="w-100" *ngIf="settings.allowCategories && categories && categories.length">{{ objective.categoryName }}</div>
            <div class="w-50">
              <span class="badge" [style.backgroundColor]="objective.statusColor">
                {{ objective.statusName }}
              </span>
            </div>
            <div class="w-100">{{ objective.dueDate | employeeDate | async }}</div>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <app-profile-picture class="mx-2" [title]="objective?.creator" [text]="objective?.creator" [whoId]="objective.createdById" [whoKind]="objective.createdByType == 4 ? 3 : objective.createdByType" [width]="20"> </app-profile-picture>
                <div class="ms-3">
                  {{ objective.createdDate | employeeDate | async }}
                </div>
              </div>
            </div>
            <div class="w-50" *ngIf="showWeight">{{ objective.weight }}</div>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</ng-template>

<ng-template #objectivesTable let-objectives="objectives" let-objectiveCategory="objectiveCategory">
  <ul class="list-group list-group-flush">
    <li class="list-group-item">
      <div class="d-flex gap-2 align-items-center performance--table header">
        <div class="w-100" (click)="changeSort(1)">
          <span>
            {{ 'name' | label : 'general' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 1 && sort.dir,
                'fa-sort-down': sort.column == 1 && !sort.dir,
                'fa-sort': sort.column != 1
              }"
            ></i>
          </span>
        </div>
        <div *ngIf="settings.allowTeamGoals && types && types.length && !studentId" class="w-100" (click)="changeSort(2)">
          <span>
            {{ 'type' | label : 'goals' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 2 && sort.dir,
                'fa-sort-down': sort.column == 2 && !sort.dir,
                'fa-sort': sort.column != 2
              }"
            ></i>
          </span>
        </div>
        <div *ngIf="settings.allowCategories && categories && categories.length && !studentId" class="w-100" (click)="changeSort(3)">
          <span>
            {{ 'category' | label : 'general' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 3 && sort.dir,
                'fa-sort-down': sort.column == 3 && !sort.dir,
                'fa-sort': sort.column != 3
              }"
            ></i>
          </span>
        </div>
        <div class="w-50" (click)="changeSort(4)">
          <span>
            {{ 'status' | label : 'general' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 4 && sort.dir,
                'fa-sort-down': sort.column == 4 && !sort.dir,
                'fa-sort': sort.column != 4
              }"
            ></i>
          </span>
        </div>
        <div class="w-100" (click)="changeSort(5)">
          <span>
            {{ 'due_date' | label : 'goals' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 5 && sort.dir,
                'fa-sort-down': sort.column == 5 && !sort.dir,
                'fa-sort': sort.column != 5
              }"
            ></i>
          </span>
        </div>
        <div class="w-100" (click)="changeSort(6)">
          <span>
            {{ 'create_by_on' | label : 'goals' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 6 && sort.dir,
                'fa-sort-down': sort.column == 6 && !sort.dir,
                'fa-sort': sort.column != 6
              }"
            ></i>
          </span>
        </div>
        <div *ngIf="showWeight" class="w-50" (click)="changeSort(7)">
          <span>
            {{ 'weight' | label : 'goals' | async }}
            <i
              class="fas cursor-pointer"
              [ngClass]="{
                'fa-sort-up': sort.column == 7 && sort.dir,
                'fa-sort-down': sort.column == 7 && !sort.dir,
                'fa-sort': sort.column != 7
              }"
            ></i>
          </span>
        </div>
        <div class="w-100" *ngIf="enableScoring">
          <span>{{ 'score' | label : 'general' | async }} </span>
        </div>
        <div class="d-flex edit-column justify-content-end align-items-end cursor-pointer">
          {{ 'actions' | label : 'general' | async }}
        </div>
      </div>
    </li>
  </ul>
  <ul class="list-group mb-5">
    <ng-container *ngFor="let objective of objectives">
      <ng-container *ngIf="isInCurrentConversation(objective.objectiveId)">
        <li class="list-group-item list-group-item-action" (click)="openObjectiveDetail(objective)" [ngClass]="{ 'active-row': objective.objectiveId == activeObjective?.objectiveId }">
          <div class="d-flex gap-2 align-items-center performance--table">
            <div class="w-100 text-break" style="min-width: 0" [title]="objective.name"><i class="fas fa-fw me-1" [ngClass]="objective.typeId == 1 ? 'fa-users' : 'fa-user'" [ngbTooltip]="objective.typeName" placement="end" container="body"></i>{{ objective.name }}</div>

            <div class="w-100 text-truncate" *ngIf="settings.allowTeamGoals && types && types.length && !studentId" [title]="objective.typeName">
              {{ objective.typeName }}
            </div>
            <div class="w-100 text-truncate" *ngIf="settings.allowCategories && categories && categories.length && !studentId" [title]="objective.categoryName">
              {{ objective.categoryName }}
            </div>
            <div class="w-50">
              <span class="badge" [style.backgroundColor]="objective.statusColor">
                {{ objective.statusName }}
              </span>
            </div>
            <div class="w-100" [title]="objective.dueDate">
              {{ objective.dueDate | employeeDate | async }}
            </div>
            <div class="w-100">
              <div class="d-flex align-items-center">
                <app-profile-picture class="mx-2" [title]="objective?.creator" [text]="objective?.creator" [whoId]="objective.createdById" [whoKind]="objective.createdByType == 4 ? 3 : objective.createdByType" [width]="20"> </app-profile-picture>
                <div class="ms-3">{{ objective.createdDate | employeeDate | async }}</div>
              </div>
            </div>
            <div class="w-50" *ngIf="showWeight">{{ objective.weight | number : '1.0-2' }}%</div>
            <div class="w-100" *ngIf="enableScoring">
              <div class="levels" *ngIf="enableScoring">
                <div class="d-flex" [ngClass]="scoreMethod == ConversationScoreMethod.RatingScale && customScoringScale?.levels?.length ? 'align-items-center' : 'align-items-end'">
                  <div class="flex-shrink-0">
                    <app-profile-picture class="mx-2" [title]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [text]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [whoId]="currentEmployee.studentId" [whoKind]="getRoleUserLevel(conversationTemplateRole)" [width]="20" [backgroundWhite]="true" [ngbTooltip]="(getRoleName(conversationTemplateRole) | label : 'general' | async) + ' ' + student.fullName" container="body"> </app-profile-picture>
                  </div>
                  <div class="ms-2 flex-grow-1">
                    <ul *ngIf="scoreMethod == ConversationScoreMethod.RatingScale && customScoringScale?.levels?.length">
                      <li
                        *ngFor="let rating of customScoringScale.levels"
                        class="level"
                        [style.width.%]="100 / customScoringScale.levels.length"
                        [ngClass]="{
                          scored: objective.score !== null && objective.score !== undefined && objective.score >= rating.sortOrder,
                          score: objective.score !== null && objective.score !== undefined && objective.score == rating.sortOrder,
                          previous: objective.previousScore !== undefined && objective.previousScore !== null && objective.previousScore == rating.sortOrder
                        }"
                        [ngbTooltip]="getRatingTooltip(rating)"
                        position="top"
                        container="body"
                        (click)="saveObjectiveScore(objective, rating, objectives)"
                      ></li>
                    </ul>

                    <div *ngIf="scoreMethod != ConversationScoreMethod.RatingScale">
                      <ng-container *ngIf="objective.previousScore !== undefined && objective.previousScore !== null">
                        <div class="d-flex justify-content-end">
                          <div class="row flex-grow-1" style="max-width: 300px">
                            <div class="col-6">
                              <div>
                                <b>{{ 'score' | label : 'general' | async }}</b>
                              </div>
                              <div>
                                <input class="form-control form-control-sm text-end" style="width: 60px; display: inline-block" name="scorePerItem{{ objective.objectiveId }}" [max]="customScoringPercentage ?? 100" [(ngModel)]="objective.score" inputmode="numeric" pattern="[0-9]*" appDigitOnly maxlength="3" (ngModelChange)="objectiveScored()" [required]="scoringIsMandatory" />
                                &nbsp;%
                              </div>
                            </div>
                            <div class="col-6">
                              <div>
                                <b>{{ 'previous_score' | label : 'conversations' | async }}</b>
                              </div>
                              <div>{{ objective.previousScore }}&nbsp;%</div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="objective.previousScore === undefined || objective.previousScore === null">
                        <input class="form-control form-control-sm text-end" style="width: 60px; display: inline-block" name="scorePerItem{{ objective.objectiveId }}" [max]="customScoringPercentage ?? 100" [(ngModel)]="objective.score" inputmode="numeric" pattern="[0-9]*" appDigitOnly maxlength="3" (ngModelChange)="objectiveScored()" [required]="scoringIsMandatory" />
                        &nbsp;%
                      </ng-container>
                    </div>

                    <div *ngIf="scoreMethod != ConversationScoreMethod.RatingScale && customScoringPercentage" class="mt-2">
                      <p class="muted" style="font-size: 11px">{{ 'maximum' | label : 'conversations' | async }} {{ 'score' | label : 'general' | async | lowercase }}: {{ customScoringPercentage }}%</p>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="objective.feedback" class="input-others">
                <ng-container *ngFor="let feedback of objective.feedback; let j = index">
                  <div class="input-other pt-4" *ngIf="feedback.createdById != currentEmployee.studentId || feedback.createdByKind != conversationTemplateRole">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <app-profile-picture class="mx-2" [title]="feedback.creator" [text]="feedback.creator" [whoId]="feedback.createdById" [whoKind]="getRoleUserLevel(feedback.createdByKind)" [width]="20" [backgroundWhite]="true" [ngbTooltip]="(getRoleName(feedback.createdByKind) | label : 'general' | async) + ' ' + feedback.creator + ' ' + (feedback.createdDate | employeeDate | async)" container="body"> </app-profile-picture>
                      </div>
                      <div class="flex-grow-1 ms-2" [ngClass]="scoreMethod == ConversationScoreMethod.RatingScale && customScoringScale ? 'flex-grow-1' : ''">
                        <div class="row">
                          <div class="col-12">
                            <div class="levels" *ngIf="enableScoring">
                              <ul *ngIf="scoreMethod == ConversationScoreMethod.RatingScale && customScoringScale && customScoringScale.levels.length">
                                <li
                                  *ngFor="let rating of customScoringScale.levels"
                                  class="level readonly"
                                  [style.width.%]="100 / customScoringScale.levels.length"
                                  [ngClass]="{
                                    scored: feedback.scorePerItem != undefined && feedback.scorePerItem >= rating.sortOrder,
                                    score: feedback.scorePerItem != undefined && feedback.scorePerItem == rating.sortOrder,
                                    previous: feedback.previousScore !== undefined && feedback.previousScore !== null && feedback.previousScore == rating.sortOrder
                                  }"
                                  [ngbTooltip]="getRatingTooltip(rating)"
                                  position="top"
                                  container="body"
                                ></li>
                              </ul>

                              <div *ngIf="scoreMethod != ConversationScoreMethod.RatingScale">
                                <ng-container *ngIf="feedback.previousScore !== undefined && feedback.previousScore !== null">
                                  <div class="d-flex justify-content-end">
                                    <div class="row flex-grow-1" style="max-width: 300px">
                                      <div class="col-6">
                                        <div>
                                          <b>{{ 'score' | label : 'general' | async }}</b>
                                        </div>
                                        <div>{{ feedback.scorePerItem }}%</div>
                                      </div>
                                      <div class="col-6">
                                        <div>
                                          <b>{{ 'previous_score' | label : 'conversations' | async }}</b>
                                        </div>
                                        <div>{{ feedback.previousScore }}%</div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="objective.previousScore === undefined || objective.previousScore === null"> {{ feedback.scorePerItem }}% </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="d-flex gap-1 edit-column justify-content-end cursor-pointer edit-column">
              <!-- clone -->
              <a class="cursor-pointer" *ngIf="isHr || isManager || (!(isEmployee && !rights.canCreate) && settings.cloneObjectives); else cloneDisabled" (click)="cloneObjective(addObjectiveModal, objective)" ngbTooltip="{{ 'cloneobjectives' | label : 'set006' | async }}" placement="top" container="body">
                <i class="fa-fw far fa-clone fs-5 accent-icon"></i>
              </a>
              <ng-template #cloneDisabled>
                <a class="disabled-icon" ngbTooltip="{{ 'goal_not_allow_clone' | label : 'goals' | async }}" placement="top" container="body">
                  <i class="fa-fw far fa-clone fs-5 grey-icon"></i>
                </a>
              </ng-template>
              <!-- edit -->
              <a class="cursor-pointer table-icon-link" *ngIf="isHr || isManager || !((isEmployee && !rights.canEdit) || objective.createdById != currentEmployee.studentId); else editDisabled" (click)="$event.stopPropagation(); editPerformanceObjective(EditPerformanceModal, objective)" ngbTooltip="{{ 'edit' | label : 'general' | async }}" placement="top" container="body">
                <i class="far fa-fw fa-edit fs-5 accent-icon"></i>
              </a>
              <ng-template #editDisabled>
                <a class="disabled-icon table-icon-link" ngbTooltip="{{ 'not_allowed_to_edit' | label : 'goals' | async }}" placement="top" container="body">
                  <i class="far fa-fw fa-edit fs-5"></i>
                </a>
              </ng-template>
              <!-- delete -->
              <a class="cursor-pointer table-icon-link" *ngIf="(isHr || isManager || !((isEmployee && !rights.canDelete) || objective.hasLinkedObjectives || objective.createdById != currentEmployee.studentId)) && !minimumReached(objectiveCategory); else deleteDisabled" (click)="deletePerformanceObjective(objective)" ngbTooltip="{{ 'delete' | label : 'general' | async }}" placement="top" container="body">
                <i class="far fa-fw fa-trash-alt fs-5 delete-icon"></i>
              </a>
              <ng-template #deleteDisabled>
                <a class="disabled-icon table-icon-link" [ngbTooltip]="(minimumReached(objectiveCategory) ? 'minimum_reached' : 'not_allowed_to_delete') | label : 'goals' | async" placement="top" container="body">
                  <i class="far fa-fw fa-trash-alt fs-5"></i>
                </a>
              </ng-template>
            </div>
          </div>
        </li>
      </ng-container>
    </ng-container>
    <!--Statistics-->
    <ng-container *ngIf="settings.allowCategories && objectiveCategory?.statistics">
      <div class="row mt-4">
        <div class="col-4">
          <div class="d-flex align-items-center">
            <span *ngIf="settings.limitedOnCategory" class="fw-bold me-2 align-middle d-flex align-items-center"
              ># {{ objectiveCategory.totalObjectives }} <ng-container *ngIf="objectiveCategory?.category?.maxNumber > 0">/ {{ objectiveCategory?.category?.maxNumber }}</ng-container> {{ 'objectives' | label : 'goals' | async }}</span
            >
            <div *ngIf="false" class="position-relative" ngbTooltip="{{ getTooltipMessage(objectiveCategory.category) }}" placement="top" container="body">
              <button class="btn mb-0 d-flex align-items-center" type="submit" (click)="addObjectivePerCategory(addObjectiveModal, objectiveCategory.category?.id)" [disabled]="isButtonDisabled(objectiveCategory.category) && settings.limitedOnCategory" *ngIf="(isHr || rights.canCreate) && objectiveCategory.category">+ {{ 'add_goal' | label : 'managerdashboard' | async }}</button>
            </div>
          </div>
        </div>
        <div *ngIf="showWeight && settings.limitedOnCategory" class="col-8 d-flex align-items-center justify-content-end">
          <span class="h-100 align-items-end fw-bold me-3 align-middle d-flex">{{ 'total_weight' | label : 'goals' | async }}:</span>

          <div class="d-flex flex-column" style="width: 40%">
            <div class="d-flex justify-content-end">
              <span class="progress-label">{{ objectiveCategory.category?.weight }}</span>
            </div>
            <div class="mt-2">
              <ngb-progressbar textType="white" [value]="objectiveCategory.totalWeight" height="18px" [max]="objectiveCategory.statistics?.maxWeight" class="w-100"> {{ objectiveCategory.totalWeight }}% </ngb-progressbar>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ul>
</ng-template>
